import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, NavController, } from '@ionic/angular';
import { ConfigService } from 'src/providers/config/config.service';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';

@Component({
  selector: 'app-confirm-pagos',
  templateUrl: './confirm-pagos.page.html',
  styleUrls: ['./confirm-pagos.page.scss'],
})
export class ConfirmPagosPage implements OnInit {

  searchQuery: string = '';
  items;


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public config: ConfigService,
    public modalCtrl: ModalController,
    public shared: SharedDataService) {

  }

  //close modal
  dismiss() {
   
    this.modalCtrl.dismiss({estado:'OK'});
    this.shared.currentOpenedModel = null;
  }

  ngOnInit() {
  }
}
